import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    className: "mail_svg__icon mail_svg__icon--mail"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.828 4H3.162C1.972 4 1 4.96 1 6.133v11.734C1 19.04 1.971 20 3.162 20h17.676c1.19 0 2.162-.96 2.162-2.133V6.133C22.99 4.96 22.02 4 20.828 4Zm0 1.333c.083 0 .165.027.239.054l-7.596 5.849c-.87.675-2.09.675-2.96 0l-7.596-5.85c.083-.026.156-.053.247-.053h17.666Zm0 13.334H3.162a.795.795 0 0 1-.788-.8v-11.2l7.285 5.609a3.852 3.852 0 0 0 4.673 0l7.284-5.61v11.2a.79.79 0 0 1-.788.8Z"
  })));
};

export { SvgMail as default };
//# sourceMappingURL=mail.svg.js.map
